export default __webpack_public_path__ + "static/media/rubik-v12-latin-900.a49cbb68.svg";